import { render, staticRenderFns } from "./base-file-input.vue?vue&type=template&id=6ed89567&scoped=true&"
import script from "./base-file-input.vue?vue&type=script&lang=js&"
export * from "./base-file-input.vue?vue&type=script&lang=js&"
import style0 from "./base-file-input.vue?vue&type=style&index=0&id=6ed89567&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed89567",
  null
  
)

export default component.exports